module.exports = __webpack_public_path__ + "img/stanford.212d9d2f.png";